import {
  breakpoints,
  colors,
  effects,
  shapes,
  spacing,
  sizes,
  typography,
  icon
} from '../tokens'

export const theme = {
  name: 'hav-theme',
  breakpoints,
  colors,
  effects,
  shapes,
  spacing,
  sizes,
  typography,
  icon
} as const
